/* @tencent/qb-auth-send-h5@1.0.0 */
import { Base64 } from 'base64-string';

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function (method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

/**
 *
 * @param obj
 * @param path
 * @param defaultValue
 * @param isUndefinedForced FIXME 由于原来默认值用null，为了兼容增加第四个值强制将defaultValue置成undefined
 * @returns {*}
 */
function getObjProps(obj, path) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var isUndefinedForced = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  try {
    var v = (path.split ? path.split('.') : [path]).reduce(function (o, p) {
      return o === null || o === void 0 ? void 0 : o[p];
    }, obj);
    return v === undefined && !isUndefinedForced ? defaultValue : v;
  } catch (error) {
    return !isUndefinedForced ? defaultValue : undefined;
  }
}
function getApi(api) {
  var executor = getObjProps(window, api);
  if (typeof executor !== 'function') {
    console.error("qb jsapi not found: ".concat(api));
    return undefined;
  }
  return executor;
}
/**
 *
 * @param api api字符 如browser.login.getAccountInfo
 * @param resolveIndex 成功回调参数位置 默认0 如不需要则设为<0
 * @param rejectIndex 失败回调参数位置 默认1 如不需要则设为<0
 * @returns
 */
function promisify(api, resolveIndex, rejectIndex) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return new Promise(function (resolve, reject) {
      var executor = getApi(api);
      if (typeof executor !== 'function') {
        return reject("".concat(api, " is not available"));
      }
      var params = [].concat(args);
      var resIndex = resolveIndex || 0;
      if (resIndex >= 0) {
        params.splice(resIndex, 0, resolve);
      }
      var rejIndex = rejectIndex || 1;
      if (rejIndex >= 0) {
        params.splice(rejIndex, 0, reject);
      }
      console.log('jsapi params', api, params);
      executor.apply(void 0, _toConsumableArray(params));
    });
  };
}

var QBAccountModule = {
  /**
   * 获取上次登录类型
   * 返回 previousType: 0表示未知，1表示QQ，2表示微信，4表示QQ互联登录，6表示手机登录
   */
  getAccountInfo: function getAccountInfo() {
    return promisify('browser.login.getAccountInfo')();
  },
  getPreviousLoginType: function getPreviousLoginType() {
    return null;
  },
  /**
   * 业务需要在dataMap中传形如key_from_where: 10000，标记调用来源
   */
  refreshToken: function refreshToken(option) {
    return promisify('browser.login.refreshToken', 1)(option);
  },
  showLoginPanel: function showLoginPanel() {
    var fromWhere = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '10000';
    var dataMap = arguments.length > 1 ? arguments[1] : undefined;
    return promisify('browser.login.showLoginPanel')({
      fromWhere: fromWhere,
      dataMap: dataMap
    });
  },
  doQuickLogin: function doQuickLogin() {
    return null;
  },
  checkLoginAppInstalled: function checkLoginAppInstalled() {
    return null;
  },
  getAccountInfoWithAppID: function getAccountInfoWithAppID() {
    return null;
  },
  doQuickLoginWithAppID: function doQuickLoginWithAppID() {
    return null;
  },
  doLogoutWithAppID: function doLogoutWithAppID() {
    return null;
  },
  showLoginSelectPanel: function showLoginSelectPanel() {
    return null;
  },
  hasGuestLogin: function hasGuestLogin() {
    return null;
  },
  getGuestAccountInfo: function getGuestAccountInfo() {
    return null;
  },
  isRealName: function isRealName() {
    return null;
  },
  doRealName: function doRealName() {
    return null;
  }
};
var QBAccountModule$1 = QBAccountModule;

var QBDeviceModule = {
  getDeviceInfo: function getDeviceInfo() {
    return promisify('browser.app.getBrowserParam')();
  },
  getQADID: function getQADID() {
    return null;
  },
  getQAID: function getQAID() {
    return promisify('browser.device.getQAID')();
  },
  getTAID: function getTAID() {
    return promisify('browser.device.getTAID')();
  },
  getOAID: function getOAID() {
    return promisify('browser.device.getOAID')();
  },
  getBattery: function getBattery() {
    return null;
  }
};
var QBDeviceModule$1 = QBDeviceModule;

var base64 = new Base64();
var ProxyUrl = 'https://qbh5.qq.com/h5-dev';
var accountType2TokenType = function accountType2TokenType(accountType) {
  switch (accountType) {
    // 微信
    case 2:
      return 2;
    // qq互联
    case 4:
      return 7;
    // 手机登录
    case 6:
      return 9;
    // qq wt登录
    case 1:
      return 5;
    default:
      return accountType;
  }
};
var encodeMap = {
  'json': '0',
  'base64': '1'
};
var retCodeMap = {
  refreshToken: '-28'
};
var authSend = function authSend(options, body, extInfo) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var _yield$getAccountAndD, accountInfo, deviceInfo, accessHeader, requestBody, headers, res, newAccountInfo, newAccessHeader, newrequestBody;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return getAccountAndDeviceInfo(extInfo);
        case 2:
          _yield$getAccountAndD = _context.sent;
          accountInfo = _yield$getAccountAndD.accountInfo;
          deviceInfo = _yield$getAccountAndD.deviceInfo;
          if (!(options.isAuth && !((accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.uin) && accountInfo.uin !== 'default_user'))) {
            _context.next = 7;
            break;
          }
          return _context.abrupt("return", Promise.reject(new Error('need to authenticate, please log in first!')));
        case 7:
          accessHeader = buildAccessHeader(options, accountInfo, deviceInfo);
          requestBody = buildRequestBody(options, accessHeader, body);
          headers = {
            'Content-Type': 'application/json',
            'q-h5-type': encodeMap[options.encode] || '0'
          };
          _context.prev = 10;
          _context.next = 13;
          return post(headers, requestBody, options);
        case 13:
          res = _context.sent;
          if (!((res === null || res === void 0 ? void 0 : res['trpc-ret']) === retCodeMap.refreshToken)) {
            _context.next = 21;
            break;
          }
          _context.next = 17;
          return QBAccountModule$1.refreshToken({
            uin: accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.uin
          });
        case 17:
          newAccountInfo = _context.sent;
          newAccessHeader = buildAccessHeader(options, newAccountInfo, deviceInfo);
          newrequestBody = buildRequestBody(options, newAccessHeader, body);
          return _context.abrupt("return", post(headers, newrequestBody, options));
        case 21:
          return _context.abrupt("return", handlerBody(res, options.encode));
        case 24:
          _context.prev = 24;
          _context.t0 = _context["catch"](10);
          return _context.abrupt("return", Promise.reject(_context.t0));
        case 27:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[10, 24]]);
  }));
};
var post = function post(headers, body, options) {
  return new Promise(function (resolve, reject) {
    fetch((options === null || options === void 0 ? void 0 : options.url) || ProxyUrl, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(body)
    }).then(function (response) {
      var headers = response.headers,
        status = response.status;
      var ret = headers.get('trpc-ret');
      var funcRet = headers.get('trpc-func-ret');
      if (status >= 200 && status < 300 && ret === '0' && funcRet === '0') {
        if (encodeMap[options.encode] === '1') {
          return response.text();
        }
        return response.text();
      }
      return Promise.reject({
        status: status,
        'trpc-ret': ret,
        'trpc-func-ret:': funcRet,
        'trpc-error-msg': headers.get('trpc-error-msg')
      });
    }).then(function (data) {
      return resolve(data);
    })["catch"](function (err) {
      return reject(err);
    });
  });
};
var getAccountAndDeviceInfo = function getAccountAndDeviceInfo(extInfo) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var accountInfo, deviceInfo, _yield$Promise$all, _yield$Promise$all2;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          accountInfo = {}, deviceInfo = {};
          _context2.prev = 1;
          if (!(!(extInfo === null || extInfo === void 0 ? void 0 : extInfo.accountInfo) && !(extInfo === null || extInfo === void 0 ? void 0 : extInfo.deviceInfo))) {
            _context2.next = 11;
            break;
          }
          _context2.next = 5;
          return Promise.all([QBAccountModule$1.getAccountInfo(), QBDeviceModule$1.getDeviceInfo()]);
        case 5:
          _yield$Promise$all = _context2.sent;
          _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
          accountInfo = _yield$Promise$all2[0];
          deviceInfo = _yield$Promise$all2[1];
          _context2.next = 23;
          break;
        case 11:
          _context2.t0 = extInfo === null || extInfo === void 0 ? void 0 : extInfo.accountInfo;
          if (_context2.t0) {
            _context2.next = 16;
            break;
          }
          _context2.next = 15;
          return QBAccountModule$1.getAccountInfo();
        case 15:
          _context2.t0 = _context2.sent;
        case 16:
          accountInfo = _context2.t0;
          _context2.t1 = extInfo === null || extInfo === void 0 ? void 0 : extInfo.deviceInfo;
          if (_context2.t1) {
            _context2.next = 22;
            break;
          }
          _context2.next = 21;
          return QBDeviceModule$1.getDeviceInfo();
        case 21:
          _context2.t1 = _context2.sent;
        case 22:
          deviceInfo = _context2.t1;
        case 23:
          return _context2.abrupt("return", {
            accountInfo: accountInfo,
            deviceInfo: deviceInfo
          });
        case 26:
          _context2.prev = 26;
          _context2.t2 = _context2["catch"](1);
          console.error('getAccountAndDeviceInfo execute error:', _context2.t2);
          return _context2.abrupt("return", {
            accountInfo: accountInfo,
            deviceInfo: deviceInfo
          });
        case 30:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[1, 26]]);
  }));
};
var handlerBody = function handlerBody(body, encode) {
  if (encodeMap[encode] === '1') {
    // 业务选择了base64编解码方式，因此回包需要解码
    return JSON.parse(base64.decode(body));
  }
  return JSON.parse(body);
};
var buildAccessHeader = function buildAccessHeader(options, accountInfo, deviceInfo) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j;
  return {
    'Q-RT': {
      servant_name: options.servantName,
      func_name: options.funcName,
      request_id: Math.floor(Date.now() / 1000)
    },
    'Q-AT': {
      qbid: (_a = accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.qbid) !== null && _a !== void 0 ? _a : '',
      account_id: (_b = accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.uin) !== null && _b !== void 0 ? _b : '',
      account_type: (_c = accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.type) !== null && _c !== void 0 ? _c : 0,
      token: (_d = accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.token) !== null && _d !== void 0 ? _d : '',
      token_type: accountType2TokenType((_e = accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.type) !== null && _e !== void 0 ? _e : 0),
      appid: (_f = accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.appid) !== null && _f !== void 0 ? _f : ''
    },
    'Q-DE': {
      guid: (_g = deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.guid) !== null && _g !== void 0 ? _g : '',
      qua2: (_h = deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.qua) !== null && _h !== void 0 ? _h : '',
      qimei36: (_j = deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.qimei36) !== null && _j !== void 0 ? _j : ''
    }
  };
};
var buildRequestBody = function buildRequestBody(options, accessHeader, body) {
  var bodyString = body;
  if (encodeMap[options.encode] === '1') {
    bodyString = base64.encode(JSON.stringify(bodyString));
  }
  return {
    'Q-HD': base64.encode(JSON.stringify(accessHeader)),
    'Q-BD': bodyString
  };
};

export { authSend };
